import { IonFab, IonGrid, ModalController, Platform, MenuController, ToastController, AlertController } from '@ionic/angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-name',
  templateUrl: './name.page.html',
  styleUrls: ['./name.page.scss', '../register.scss'],
})
export class NamePage {
  public load = false;
  public loadingMessage = '';
  name: string;
  email: string;
  phone: string = '';
  password: string;
  public messageErrorName: any = {
    message: '',
    status: false,
  };
  public messageErrorEmail: any = {
    message: '',
    status: false,
  };
  public messageErrorPhone: any = {
    message: '',
    status: false,
  };
  public errorMessages = [
    'O campo senha não pode estar vazio.',
    'A senha deve conter pelo menos 8 caracteres.',
    'A senha deve conter pelo menos uma letra maiúscula.',
    'A senha deve conter pelo menos uma letra minúscula.',
    'A senha deve conter pelo menos um número.',
  ];
  public errorMessagesValidity = Array(this.errorMessages.length).fill(false);
  public passwordIsValid = false;
  @ViewChild('grid') private grid: IonGrid;
  @ViewChild('fab') private fab: IonFab;
  users: any = {};
  public loadGoogle = false;
  public showPassword = false;

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
    private menu: MenuController,
    private httpService: HttpService,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private authService: AuthService
  ) {}

  ionViewWillEnter() {
    // Disable the side menu for this page
    this.menu.enable(false, 'principalMenu');
    this.updateUser();
  }

  ionViewWillLeave() {
    // Re-enable the side menu when leaving this page
    this.menu.enable(true, 'principalMenu');
  }

  back() {
    this.modalCtrl.dismiss();
  }

  async loginWithGoogle() {
    this.loadGoogle = true;
    try {
      const idToken = await this.authService.signInWithGoogle();
      const data: any = await this.httpService.post('auth/google', { idToken }).toPromise();
      localStorage.setItem('token', JSON.stringify(data.token));
      this.authService.attachPendingGoogleRefreshToken();
      this.updateUserLocalStorage(data);
      localStorage.setItem('loginStatusDB', JSON.stringify(true));
      await this.modalCtrl.dismiss();
      location.replace('home');
    } catch (err: any) {
      const msg = err?.error?.message || err?.message || 'Não foi possível continuar com Google.';
      this.presentToast(msg, 'danger');
    } finally {
      this.loadGoogle = false;
    }
  }

  changeName() {
    this.messageErrorName.status = false;
  }

  changeEmail() {
    this.messageErrorEmail.status = false;
  }

  changePhone() {
    this.messageErrorPhone.status = false;
    let raw = (this.phone || '').replace(/\D/g, '');
    if (raw.startsWith('55') && raw.length > 11) raw = raw.slice(2);
    const digits = raw.slice(0, 11);
    if (digits.length === 0) {
      this.phone = '';
    } else if (digits.length <= 2) {
      this.phone = '(' + digits;
    } else if (digits.length <= 7) {
      this.phone = '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    } else {
      this.phone = '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + '-' + digits.slice(7, 11);
    }
  }

  formatPhoneFromDigits(digits: string): string {
    if (!digits) return '';
    let d = digits.replace(/\D/g, '');
    if (d.startsWith('55') && d.length > 11) d = d.slice(2);
    d = d.slice(0, 11);
    if (d.length === 0) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 7) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7, 11);
  }

  validatePassErrors() {
    if (!this.password) {
      this.password = '';
    }
    
    // Check each validation rule individually
    const hasMinLength = this.password.length >= 8;
    const hasUppercase = /[A-Z]/.test(this.password);
    const hasLowercase = /[a-z]/.test(this.password);
    const hasNumber = /\d/.test(this.password);
    const isNotEmpty = this.password.length > 0;
    
    // Update validation array
    this.errorMessagesValidity = [
      isNotEmpty,           // Not empty
      hasMinLength,        // At least 8 characters
      hasUppercase,         // At least one uppercase letter
      hasLowercase,         // At least one lowercase letter
      hasNumber            // At least one number
    ];
    
    // Password is valid only if all conditions are met
    this.passwordIsValid = this.errorMessagesValidity.every((v) => v === true);
  }

  async requestPasswordRecover() {
    this.load = true;
    try {
      await this.httpService.post('recoverPass', { email: this.email }).toPromise();
      await this.presentToast('Email enviado para: ' + this.email, 'primary');
    } catch (e) {
      await this.presentToast('Um erro ocorreu');
    }
    this.load = false;
  }

  async presentToast(message: string, color = 'danger') {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2000,
      color,
      cssClass: 'ft-sz-16 ion-text-center',
    });
    toast.present();
  }

  private resetLoading() {
    this.load = false;
    this.loadingMessage = '';
  }

  async nextPage() {
    try {
      this.load = true;
      this.loadingMessage = 'Validando dados...';

      // Validate name
      if (!this.name || this.name.length < 3) {
        this.messageErrorName.message = 'O nome digitado é muito pequeno.';
        this.messageErrorName.status = true;
        this.resetLoading();
        return;
      }

      // Validate email
      const re = /\S+@\S+\.\S+/;
      if (!re.test(this.email)) {
        this.messageErrorEmail.message = 'O email digitado é invalido!';
        this.messageErrorEmail.status = true;
        this.resetLoading();
        return;
      }

      // Check if email already exists
      this.loadingMessage = 'Verificando e-mail...';
      try {
        const response = await this.httpService.post('login-methods', this.email).toPromise();
        if ((response as any).message === 'Usuário encontrado') {
          this.messageErrorEmail.message = 'Email já cadastrado no iPlanta';
          this.messageErrorEmail.status = true;
          this.resetLoading();
          return;
        }
      } catch (e: any) {
        const errorCode = e?.error?.code || e?.code;
        const httpStatus = e?.status;

        // 404 or auth/user-not-found means email is available - this is expected for registration
        if (httpStatus === 404 || errorCode === 'auth/user-not-found') {
          // Email not found = available for registration, continue
        } else if (errorCode === 'auth/internal-error') {
          this.resetLoading();
          this.messageErrorEmail.message =
            'Um erro inesperado aconteceu nos servidores. Tente novamente mais tarde';
          this.messageErrorEmail.status = true;
          return;
        } else if (errorCode === 'auth/invalid-email') {
          this.resetLoading();
          this.messageErrorEmail.message = 'O email fornecido é inválido';
          this.messageErrorEmail.status = true;
          return;
        } else {
          // For any other error, log but continue registration attempt
          console.warn('Email check returned unexpected error, continuing registration:', e);
        }
      }

      // Validate password
      if (!this.passwordIsValid) {
        this.resetLoading();
        return;
      }

      // Validate phone
      const phoneValue = (this.phone || '').trim();
      if (!phoneValue || phoneValue.length < 15) {
        this.messageErrorPhone.message = 'É necessário digitar um telefone.';
        this.messageErrorPhone.status = true;
        this.resetLoading();
        return;
      }
      const reLetter = /[A-Za-z]/;
      if (reLetter.test(phoneValue)) {
        this.messageErrorPhone.message = 'Seu número contém letras.';
        this.messageErrorPhone.status = true;
        this.resetLoading();
        return;
      }
      const reNumber = /[0-9]/g;
      const phoneDigits = phoneValue.match(reNumber);
      if (!phoneDigits || phoneDigits.length < 11) {
        this.messageErrorPhone.message = 'Telefone incompleto.';
        this.messageErrorPhone.status = true;
        this.resetLoading();
        return;
      }
      this.users.phone = phoneDigits.join('');

      // Save all data
      this.users.name = this.name;
      this.users.email = this.email;
      this.users.password = this.password;

      this.updateLocalStorage();

      // Criar conta (antes feito em address)
      this.loadingMessage = 'Criando sua conta...';
      try {
        await this.httpService.post('user', this.users).toPromise();
        localStorage.removeItem('userDB');

        this.loadingMessage = 'Entrando na sua conta...';
        const userData: any = await this.httpService.post('login', this.users).toPromise();
        localStorage.setItem('token', JSON.stringify(userData.token));
        localStorage.setItem('userDB', JSON.stringify(userData));
        await this.mergeGuestAddressIntoUser();
        localStorage.setItem('loginStatusDB', JSON.stringify(true));

        this.loadingMessage = 'Redirecionando...';
        await this.modalCtrl.dismiss();
        location.replace('seller-select');
      } catch (err) {
        this.resetLoading();
        const message = err.error?.message || 'Não foi possível criar a conta. Tente novamente.';
        await this.presentAlert(message, 'close-circle', 'color-dg');
      }
    } catch (e) {
      console.error(e);
      this.resetLoading();
      return;
    }
  }

  async presentAlert(message: string, icon: string, color: string) {
    const alert = await this.alertCtrl.create({
      header: message,
      cssClass: 'custom-alert',
      mode: 'ios',
      buttons: [
        {
          text: 'Fechar',
          cssClass: 'button-close',
        },
      ],
      backdropDismiss: false,
    });
    await alert.present();
  }

  updateLocalStorage() {
    localStorage.setItem('userDB', JSON.stringify(this.users));
  }

  updateUserLocalStorage(data: { user?: any; token?: any }) {
    localStorage.setItem('userDB', JSON.stringify(data));
  }

  /** If user had added an address as guest (homeFilterAddress), add it to their account and save to backend */
  private async mergeGuestAddressIntoUser() {
    try {
      const guestAddrJson = localStorage.getItem('homeFilterAddress');
      if (!guestAddrJson) return;
      const guestAddr = JSON.parse(guestAddrJson);
      if (!guestAddr || (!guestAddr.city && !guestAddr.state && !guestAddr.line_1)) return;

      const userDBJson = localStorage.getItem('userDB');
      if (!userDBJson) return;
      const userDB = JSON.parse(userDBJson);
      const user = userDB?.user || userDB;
      if (!user || !user.id) return;

      const address = {
        line_1: guestAddr.line_1 || `${guestAddr.district || ''}, ${guestAddr.city || ''}`.replace(/^,\s*/, '') || guestAddr.city || '',
        city: guestAddr.city || '',
        state: guestAddr.state || '',
        country: guestAddr.country || 'BR',
        zip_code: guestAddr.zip_code || '',
        compliment: guestAddr.compliment || '',
      };
      if (!address.line_1 && !address.city) return;

      user.address = address;
      if (!user.addresses) user.addresses = [];
      const alreadyHas = user.addresses.some(
        (a: any) => a.city === address.city && a.state === address.state && (a.line_1 === address.line_1 || !address.line_1)
      );
      if (!alreadyHas) {
        user.addresses.unshift(address);
      }
      if (userDB.user) userDB.user = user;
      else Object.assign(userDB, { user });
      localStorage.setItem('userDB', JSON.stringify(userDB));
      localStorage.setItem(`homeFilterAddress_${user.id}`, guestAddrJson);

      // Persist address on backend
      const opts = this.httpService.getOpts();
      if (opts) {
        await this.httpService.put('user/' + user.id, { address: user.address, addresses: user.addresses }, opts).toPromise();
      }
    } catch (_) {}
  }

  updateUser() {
    let userJSON = localStorage.getItem('userDB');
    if (userJSON) this.users = JSON.parse(userJSON);

    this.name = this.users.name;
    this.email = this.users.email;
    this.phone = this.users.phone ? this.formatPhoneFromDigits(this.users.phone) : '';
    this.password = this.users.password;
    
    // Validate password if it exists
    if (this.password) {
      this.validatePassErrors();
    }
  }

  navigateToStep(_step: number) {
    // Check if form is complete before allowing navigation
    if (!this.isFormComplete()) {
      this.showFormIncompleteMessage();
      return;
    }
    // All steps are on this page (name, email, phone, password) - no navigation
  }

  isFormComplete(): boolean {
    const phoneValue = (this.phone || '').trim();
    const phoneOk = phoneValue.length >= 15 && !/[A-Za-z]/.test(phoneValue) && (phoneValue.match(/[0-9]/g) || []).length >= 11;
    return !!(this.name && this.name.length >= 3 &&
              this.email && /\S+@\S+\.\S+/.test(this.email) &&
              phoneOk &&
              this.passwordIsValid);
  }

  async showFormIncompleteMessage() {
    // Highlight missing fields
    this.highlightMissingFields();
    
    const toast = await this.toastCtrl.create({
      message: 'Por favor, preencha todos os campos obrigatórios antes de continuar',
      duration: 3000,
      color: 'warning',
      cssClass: 'ft-sz-16 ion-text-center',
    });
    toast.present();
  }

  highlightMissingFields() {
    // Reset all error states
    this.messageErrorName.status = false;
    this.messageErrorEmail.status = false;
    this.messageErrorPhone.status = false;
    
    // Check and highlight missing fields
    if (!this.name || this.name.length < 3) {
      this.messageErrorName.message = 'O nome é obrigatório';
      this.messageErrorName.status = true;
    }
    
    if (!this.email || !/\S+@\S+\.\S+/.test(this.email)) {
      this.messageErrorEmail.message = 'O email é obrigatório';
      this.messageErrorEmail.status = true;
    }
    
    const phoneValue = (this.phone || '').trim();
    if (!phoneValue || phoneValue.length < 15) {
      this.messageErrorPhone.message = 'Telefone é obrigatório';
      this.messageErrorPhone.status = true;
    } else if (/[A-Za-z]/.test(phoneValue)) {
      this.messageErrorPhone.message = 'Seu número contém letras';
      this.messageErrorPhone.status = true;
    } else if ((phoneValue.match(/[0-9]/g) || []).length < 11) {
      this.messageErrorPhone.message = 'Telefone incompleto';
      this.messageErrorPhone.status = true;
    }
    
    if (!this.passwordIsValid) {
      // Password validation will be handled by the existing validation system
      this.validatePassErrors();
    }
  }
}
